import { render, staticRenderFns } from "./InstagramBusinessContentFeed.vue?vue&type=template&id=6ea70ffe"
import script from "./InstagramBusinessContentFeed.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessContentFeed.vue?vue&type=script&lang=js"
import style0 from "./InstagramBusinessContentFeed.vue?vue&type=style&index=0&id=6ea70ffe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports